// @ts-nocheck
import React, { FC, useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { whichAuth as getAuth } from '../../getAuth';
import { useSetRecoilState } from 'recoil';
import { showForgotPasswordState, showSignInState } from '../../atoms';
import {
  IonButton,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonContent,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonSpinner,
} from '@ionic/react';
import { validationEmail } from "../../utils/validationEmail";
import { AlertModal } from "../../components";

const SignIn: FC = () => {
  
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [inProgress, setInProgress] = useState<boolean>(false);
  const [showPasswordResetSent, setShowPasswordResetSent] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const setShowSignIn = useSetRecoilState(showSignInState);
  const setForgotPassword = useSetRecoilState(showForgotPasswordState);
  
  const signIn = async () => {
    setInProgress(true);
    try {
      await signInWithEmailAndPassword(getAuth(), email, password)
      setEmail('');
      setPassword('');
      setShowSignIn(false);
    } catch (error) {
      setIsOpenModal(true)
    } finally {
      setInProgress(false)
    }
  }
  
  return (
    <IonContent fullscreen>
      <IonCardContent className="h-full card-authentication">
        <IonCardContent className="left-authentication" />
        <IonCardContent className="right-authentication">
          <IonList lines="none" className="right-list-authentication">
            <IonCardHeader className="logo-authentication" />
            <IonCardSubtitle className="header-authentication">
              Sign In
            </IonCardSubtitle>
            <IonLabel className="label-authentication">Email</IonLabel>
            <IonItem fill="outline" className="no-padding">
              <IonInput
                className="input-authentication"
                onIonChange={event => setEmail(event.detail.value)}
                value={email}
                type="email"
                required
              />
            </IonItem>
            <IonLabel className="label-authentication">Password</IonLabel>
            <IonItem fill="outline" className="no-padding">
              <IonInput
                className="input-authentication"
                onIonChange={event => setPassword(event.detail.value)}
                type="password"
                required
              />
            </IonItem>
            <IonItem className="no-padding">
              <IonButton
                disabled={!password || validationEmail(email)}
                onClick={() => signIn()}
                size="medium"
                className="button-authentication"
              >
                { inProgress && <IonSpinner name="dots" /> }
                Sign in
              </IonButton>
            </IonItem>
            <IonItem className="no-padding">
              <IonButton
                onClick={() => setForgotPassword(true)}
                fill="clear"
                size="small"
              >
                Forgot password?
              </IonButton>
            </IonItem>
            <IonItem className="already-authentication no-padding">
              No account yet?
              <a className="link-authentication" onClick={() => setShowSignIn(false)}>Sign up</a>
            </IonItem>
          </IonList>
        </IonCardContent>
      </IonCardContent>
      <AlertModal
        isOpen={isOpenModal}
        title={showPasswordResetSent ? 'Password reset requested' : 'Invalid credentials'}
        subTitle={showPasswordResetSent ? 'A password reset email has been sent to you.' : ''}
        onClosed={() => {
          if (showPasswordResetSent) {
            setShowPasswordResetSent(false);
            setShowResetPassword(false);
          }
          setIsOpenModal(false)
        }}
      />
    </IonContent>
);}

export default SignIn;
